// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:07.591Z
// Property: Villas at Aspen Park (ID: 6767906449165640)
// Collections: 32 amenities, 6 floorplans (live), 40 photos, 68 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165640",
  "property_external_id": "43p3e3h",
  "property_zillow_url": "https://www.zillow.com/homedetails/2001-W-Princeton-Cir-Broken-Arrow-OK-74012/312738995_zpid/",
  "property_apartments_url": "https://www.apartments.com/villas-at-aspen-park-broken-arrow-ok/43p3e3h/",
  "property_google_business_url": "https://www.google.com/maps/place/Villas+at+Aspen+Park/data=!4m2!3m1!1s0x0:0x3be7759fa11c9997?sa=X&ved=2ahUKEwjgkIu8gr2SAxWEEFkFHahiOCkQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "villas-at-aspen-park",
  "property_name": "Villas at Aspen Park",
  "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/villas-at-aspen-park/",
  "property_domain": null,
  "property_address": "2001 W Princeton Circle",
  "property_full_address": "2001 W Princeton Circle, Broken Arrow, OK, 74012",
  "property_address_1": "2001 W Princeton Circle",
  "property_address_2": null,
  "property_address_city": "Broken Arrow",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74012",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "Downtown Broken Arrow",
  "property_address_latitude": "36.0668",
  "property_address_longitude": "-95.8139",
  "property_email": "villasataspenpark@caseusa.com",
  "property_phone": "(539) 245-4119",
  "property_call_tracking_phone": "855-643-1574",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Villas at Aspen Park in Broken Arrow, where comfort meets convenience. Our one and two-bedroom apartments feature modern amenities, including a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. Enjoy serene picnics by the pond or take your furry friend to the dog park. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Villas at Aspen Park, your ideal sanctuary in Broken Arrow, Oklahoma! Our beautifully designed apartment community offers a variety of spacious floor plans, including one and two-bedroom options, perfect for individuals, couples, or families. Experience the best of convenient living with our outstanding amenities that cater to your every need.\n\nDive into relaxation at our inviting pool, maintain your fitness goals in our fully-equipped fitness center, or unwind in the charming clubhouse. For those balancing work and home life, our business center provides the perfect workspace. Enjoy peace of mind with convenient services like maintained on-site management, package service, and 24-hour maintenance.\n\nStep outside to discover our beautifully landscaped grounds, featuring a gated entrance, serene pond, and a picnic area, ideal for gatherings with family and friends. Our dog park adds to the pet-friendly atmosphere, ensuring your furry companions feel right at home. \n\nInside your apartment, enjoy modern comforts such as air conditioning, high-speed internet access, and stylish features including high ceilings, walk-in closets, and private balconies or patios with lovely views. Each unit is equipped with essential appliances like a refrigerator, dishwasher, and washer/dryer hookup, making daily living both easy and enjoyable.\n\nAt Villas at Aspen Park, we strive to create a vibrant community that feels just like home. Don't miss your chance to join us! Find your new home today—browse our availability or schedule a tour to visit our community and start your new lifestyle in Broken Arrow! ",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fb44b-b6f5-7709-9b70-eac98f67099f.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings surrounding a pond with a fountain.",
    "public_id": "019fb44b-b6f5-7709-9b70-eac98f67099f",
    "storage_key": "property/6767906449165640/019fb44b-b6f5-7709-9b70-eac98f67099f.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "270",
  "property_year_built": "2009",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.14814814814815",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Chow, Rottweiler, Pit-Bull, Akita, American Bulldog, Doberman, German Shepherd",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://villasataspenparkapartmentsbrokenarrow.securecafe.com/onlineleasing/villas-at-aspen-park/floorplans.aspx",
  "property_resident_portal_url": "https://villasataspenparkapartmentsbrokenarrow.securecafe.com/residentservices/villas-at-aspen-park/userlogin.aspx",
  "property_apply_now_url": "https://villasataspenparkapartmentsbrokenarrow.securecafe.com/onlineleasing/villas-at-aspen-park/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-640a-759d-88d3-e2b047e77693.webp",
  "property_primary_logo_media": {
    "alt_text": "Villas at Aspen Park Apartment Homes logo.",
    "public_id": "019cfb4b-640a-759d-88d3-e2b047e77693",
    "storage_key": "property/6767906449165640/019cfb4b-640a-759d-88d3-e2b047e77693.webp",
    "width": 300,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4c-706b-749f-bb5a-88aea153779c.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb4c-706b-749f-bb5a-88aea153779c",
    "storage_key": "property/6767906449165640/019cfb4c-706b-749f-bb5a-88aea153779c.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4c-8e9c-725f-b750-586f86ee4812.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Villas at Aspen Park Apartment Homes logo",
    "public_id": "019cfb4c-8e9c-725f-b750-586f86ee4812",
    "storage_key": "property/6767906449165640/019cfb4c-8e9c-725f-b750-586f86ee4812.webp",
    "width": 300,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4c-95dd-733b-b9c3-8a0dc2dec394.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Villas at Aspen Park Apartment Homes logo",
    "public_id": "019cfb4c-95dd-733b-b9c3-8a0dc2dec394",
    "storage_key": "property/6767906449165640/019cfb4c-95dd-733b-b9c3-8a0dc2dec394.webp",
    "width": 300,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#8bc53f",
  "property_secondary_color": "#463567",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#3d3d3f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1108 - 1110",
  "property_sqft_min": "1108",
  "property_sqft_max": "1110",
  "property_price_range": "1259 - 1419",
  "property_price_min": "1259",
  "property_price_max": "1419",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/VillasAtAspenParkBrokenArrow/photos/",
  "property_instagram_url": "https://www.instagram.com/villasataspenpark/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJJw9GKgKLtocRl5kcoZ915zs",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/villas-at-aspen-park-broken-arrow",
  "property_tiktok_url": "https://www.tiktok.com/@villasataspenpark",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Villas at Aspen Park",
  "property_home_romance_title": "Embrace the Comfort of Your New Apartment Home Today",
  "property_home_amenities_blurb": "Welcome to Villas at Aspen Park, where elegance meets comfort in Broken Arrow. Choose from spacious one or two-bedroom floor plans, and indulge in amenities like a refreshing pool, modern fitness center, and serene walking trails. Your perfect home awaits, complete with high-speed internet and a welcoming dog park!",
  "property_home_floorplans_blurb": "Nestled in the heart of Broken Arrow, Oklahoma, Villas at Aspen Park offers thoughtfully designed one and two-bedroom apartments that blend comfort with modern elegance. Each spacious floor plan is tailored to fit your lifestyle. Browse our available apartment homes today and find the perfect fit for your new beginning!",
  "property_home_gallery_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, luxury meets convenience. Choose from spacious one and two-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and serene picnic area. Picture yourself enjoying scenic walking trails and cozy evenings by the fireplace—your dream home awaits!",
  "property_home_neighborhood_blurb": "Welcome to Villas at Aspen Park in Broken Arrow, Oklahoma, where vibrant community life meets cozy living spaces. Choose from our thoughtfully designed one and two-bedroom floor plans. Uncover nearby treasures and local favorites that make our neighborhood truly special—your ideal lifestyle awaits just outside your door!",
  "property_home_reviews_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, residents enjoy a tranquil atmosphere amid well-maintained grounds and spacious apartments featuring modern kitchens. Our dedicated staff swiftly addresses any maintenance needs, creating a welcoming environment. Join a community where convenience meets comfort, and see what our residents have to say!",
  "property_neighborhood_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, you’ll find spacious one and two-bedroom floor plans nestled near top educational institutions like Oral Roberts University and Broken Arrow High School. Enjoy a vibrant community with nearby parks and recreational spaces. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, luxury meets comfort with our thoughtfully designed one and two-bedroom apartments. Indulge in serene pond views, unwind by the pool, or stroll through our dog park. Experience convenience with on-site management, high-speed internet, and a fully-equipped fitness center—your perfect home awaits!",
  "property_applynow_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, you’ll find spacious one and two-bedroom apartments designed for comfort and convenience. Enjoy resort-style amenities like a refreshing pool, a well-equipped fitness center, and a cozy clubhouse. Ready to elevate your lifestyle? Lease your new home online today!",
  "property_contactus_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Whether you seek cozy solitude or a spacious retreat, our community has something for everyone. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Curious about our community? Our FAQs page is your gateway to essential information, helping you find everything you need to make an informed decision. Dive in today!",
  "property_floorplans_blurb": "Welcome to Villas at Aspen Park in Broken Arrow, Oklahoma, where comfortable living meets stunning design. Choose from spacious one and two-bedroom floor plans tailored for every lifestyle. Take a moment to browse our available apartment homes and find the ideal space that complements your unique vision of home.",
  "property_gallery_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, your ideal home awaits with spacious floor plans, inviting amenities, and serene views. Picture yourself lounging by the pool, enjoying the dog park, or hosting friends in our cozy clubhouse. Embrace comfort and style—your vibrant community experience starts here!",
  "property_interactivemap_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, a vibrant lifestyle awaits! Choose from spacious one or two-bedroom floor plans, complete with modern amenities like a sparkling pool, dog park, and fitness center. Use our interactive community map to uncover your ideal apartment and elevate your living experience today!",
  "property_pets_blurb": "At Villas at Aspen Park in Broken Arrow, OK, your furry friends are not just accepted—they’re cherished! Enjoy spacious living, picturesque surroundings, and a welcoming community. Reach out to our leasing office to learn more about our pet policy and the perfect home for you and your beloved companion.",
  "property_referafriend_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, we believe that great friends make great neighbors. With spacious one and two-bedroom floor plans, our welcoming community is perfect for sharing life’s moments. Refer a friend today and invite them to experience all the comfort and connection we offer!",
  "property_residentaccess_blurb": "At Villas at Aspen Park in Broken Arrow, Oklahoma, your ideal home awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, tailored for comfort and style. Elevate your living experience by accessing your resident portal—pay rent, schedule maintenance, and manage your lifestyle with ease right at your fingertips!",
  "property_reviews_blurb": "At Villas at Aspen Park in Broken Arrow, residents appreciate the spacious apartments and well-appointed kitchens. One happy resident noted, \"The grounds are well maintained,\" and highlighted the helpful office staff. Conveniently located near shopping and dining, our community offers a serene oasis for your lifestyle. See what our residents have to say!",
  "property_created_at": "1753982396468",
  "property_scheduletour_blurb": "Experience the charm of Villas at Aspen Park in Broken Arrow, Oklahoma, where thoughtfully designed one and two-bedroom apartments await you. Each floor plan is crafted for comfort and style. Ready to see why our residents love calling this community home? Schedule a tour today and join our vibrant living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Villas at Aspen Park in Broken Arrow, Oklahoma! Our inviting one and two-bedroom floor plans are designed for comfort and style. A member of our team will connect with you shortly to help you find your perfect home among our exceptional offerings.",
  "property_virtualtours_blurb": "Experience the charm of Villas at Aspen Park in Broken Arrow, Oklahoma. With thoughtfully designed one and two-bedroom floor plans, our vibrant community offers a perfect blend of comfort and style. Ready to envision your new home? Take a virtual tour today and see what awaits you!",
  "property_copyright": "2025 All Rights Reserved. Villas at Aspen Park",
  "property_seo_title_home": "Villas at Aspen Park | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_home": "Live effortlessly at Villas at Aspen Park in Broken Arrow! Enjoy stylish one & two-bedroom apartments with resort-style amenities. Your ideal home awaits!",
  "property_seo_title_floorplans": "Find your ideal space at Villas at Aspen Park in Broken Arrow! Choose from stylish one or two-bedroom floor plans designed for your comfort. Browse now!",
  "property_seo_description_floorplans": "Find your ideal space at Villas at Aspen Park in Broken Arrow. Choose from stylish one and two-bedroom floor plans designed for your comfort and lifestyle.",
  "property_seo_title_amenities": "Amenities | Broken Arrow, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience unmatched comfort at Villas at Aspen Park in Broken Arrow! Dive into luxury amenities, from a sparkling pool to dog parks, all designed for your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_gallery": "\"Picture your life at Villas at Aspen Park in Broken Arrow, OK! Enjoy resort-style amenities, spacious floor plans, and scenic views—all waiting for you!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Villas at Aspen Park Apartments",
  "property_seo_description_virtualtours": "Step inside the Villas at Aspen Park in Broken Arrow, OK. Experience our spacious one and two-bedroom apartments—take a virtual tour now and find your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Villas at Aspen Park Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect home at Villas at Aspen Park in Broken Arrow! Enjoy luxurious amenities like a pool, dog park, and spacious floor plans. Start your search today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Broken Arrow, OK at Villas at Aspen Park. Dive into local favorites and vibrant spots just steps from your new home. ",
  "property_seo_title_contact": "Contact Us | Villas at Aspen Park",
  "property_seo_description_contact": "Connect with the Villas at Aspen Park in Broken Arrow, OK! Inquire about our one and two-bedroom floor plans. Your ideal home awaits—reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_faqs": "Your ideal lifestyle awaits at Villas at Aspen Park in Broken Arrow! From stunning one and two-bedroom floor plans to top-notch amenities, find your perfect home today.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_reviews": "\"Join the Villas at Aspen Park community in Broken Arrow! Dive into resident reviews and see why our one and two-bedroom apartments are the perfect fit for you.\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_applynow": "Elevate your lifestyle at Villas at Aspen Park in Broken Arrow, OK! Enjoy upscale amenities, spacious floor plans, and a vibrant community. Lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Villas at Aspen Park",
  "property_seo_description_residentaccess": "Unlock your convenience at Villas at Aspen Park! Log in for quick rent payments, maintenance requests, and all your resident needs in Broken Arrow, OK.",
  "property_seo_title_referafriend": "Refer A Friend | Villas at Aspen Park",
  "property_seo_description_referafriend": "Refer a friend to Villas at Aspen Park in Broken Arrow! Great friends become great neighbors—share the love and elevate your living experience together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Villas at Aspen Park",
  "property_seo_description_scheduletour": "Experience the charm of Villas at Aspen Park in Broken Arrow, OK. Schedule your tour today and find your perfect home nestled in vibrant tranquility!",
  "property_seo_title_privacy": "Privacy Policy | Villas at Aspen Park",
  "property_seo_description_privacy": "Your privacy matters at Villas at Aspen Park. Learn how we protect your information while you enjoy life in Broken Arrow. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Villas at Aspen Park",
  "property_seo_description_accessibility": "\"At Villas at Aspen Park in Broken Arrow, we prioritize accessibility. Experience an inclusive community where everyone belongs—learn about our commitment today!\"",
  "property_seo_title_sitemap": "Sitemap | Villas at Aspen Park",
  "property_seo_description_sitemap": "Uncover the pathways to your perfect home at Villas at Aspen Park in Broken Arrow. Navigate our sitemap for a clear view of our community offerings!",
  "property_seo_title_thankyou": "Thank You | Villas at Aspen Park",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfort at Villas at Aspen Park in Broken Arrow starts now. Expect a call from our friendly team soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Broken Arrow, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866082638",
  "amenities": [
    {
      "id": "ec_0061d970e2faeb72871fb910",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397396",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a159f8d6efc81638260d26c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397397",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c54e21237c94f45ed4ff0b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397398",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_378c72b4e75ecc324ccb0785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397399",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ad04f9d2433e9088a856403",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397400",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a857c8561391b65fed0306a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397401",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b13daf9bab83f0f0c7efb3b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397403",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4016c2055a33d623b8625eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397404",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7414047c9ae8dc4b22e10e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "128033157",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28a2ec5b7851f490fdbc696b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397405",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e24ec8420bb8a6de082bad70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127397406",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14c1722059f4315286862a29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "128042559",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ec3f979c60d1619bebc6dc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398847",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6dd2453940f850672bbbc95a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398848",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c631375966ba489f009ebf8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398849",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_408e43a40ea0b4b758920db6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398850",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a2c7950f1911c869938aacd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398851",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95fc7c3593c3d3d388c8e0da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398852",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b758dd57dc2b8ff6d1a9be5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398853",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_274fa605e97e47248c2a47c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398854",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fdca9f2d10de4c992adecde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398855",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d616128e46217f13b37ad7d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398856",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86cce50e1abeb6b1329fb501",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398857",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8b894d8a9ba1fff460135e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398858",
      "title": "Furnished",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5569370a60f699f32288024",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398859",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e130ec6e781e1e98a2608db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398860",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5223e0b54b10a9fdc8a2eab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398861",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21ff034026eede4af7a93f41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398862",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3f4e9beafadf642b1b821e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398863",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6e6881f55bc0a51729c94fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398864",
      "title": "Handrails",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7fe231123696c19b8102eb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398865",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f1195639e95e038abfa2d3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "yardi",
      "external_id": "127398866",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6fa663d9-0fa8-4187-90e3-22ae11200285",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-7ab5-761b-a091-1d3e3a372888.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, dresser, and window.",
        "public_id": "019fa4fa-7ab5-761b-a091-1d3e3a372888",
        "storage_key": "property/6767906449165640/019fa4fa-7ab5-761b-a091-1d3e3a372888.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed with elegant bedding, dual nightstands, a wooden dresser, and a large window with blinds.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a06009b-30d2-40e6-bd13-b0e9e35d43a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-76ea-727c-aa6b-5b693bd9e638.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, vanity, sink, and bathtub with shower curtain.",
        "public_id": "019fa4fa-76ea-727c-aa6b-5b693bd9e638",
        "storage_key": "property/6767906449165640/019fa4fa-76ea-727c-aa6b-5b693bd9e638.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, vanity with sink, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with a toilet, vanity, sink, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d980e467-d428-4aa8-9e75-120d2d937d79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-66f6-775f-948d-ef5dc3835e8e.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
        "public_id": "019fa4fa-66f6-775f-948d-ef5dc3835e8e",
        "storage_key": "property/6767906449165640/019fa4fa-66f6-775f-948d-ef5dc3835e8e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring ample cabinet space, modern white appliances, and beautiful granite countertops.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95a9af86-d14d-414b-9b79-15ac8ce029c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-68be-77e7-bfe6-4a0f64daeb89.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and granite countertops.",
        "public_id": "019fa4fa-68be-77e7-bfe6-4a0f64daeb89",
        "storage_key": "property/6767906449165640/019fa4fa-68be-77e7-bfe6-4a0f64daeb89.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious U-shaped kitchen featuring ample wooden cabinetry, granite countertops, and modern white appliances including a stove, microwave, and dishwasher.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1495e56-6273-4a6f-a879-faa3a90abb54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-684c-739d-8caf-e8e75e20d973.webp",
      "image_media": {
        "alt_text": "Glass-top dining table with four upholstered chairs and a bowl of green fruit.",
        "public_id": "019fa4fa-684c-739d-8caf-e8e75e20d973",
        "storage_key": "property/6767906449165640/019fa4fa-684c-739d-8caf-e8e75e20d973.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals with family and friends in this elegant dining area featuring a glass-top table, comfortable seating, and abundant natural light.",
      "link": "",
      "alt_text": "Glass-top dining table with four upholstered chairs and a bowl of green fruit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_159db0d0-9295-40d3-9782-b71f7278de3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-6a04-728b-a66b-3eef19a9eadb.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and a ceiling fan.",
        "public_id": "019fa4fa-6a04-728b-a66b-3eef19a9eadb",
        "storage_key": "property/6767906449165640/019fa4fa-6a04-728b-a66b-3eef19a9eadb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant wooden furniture, and a ceiling fan for added comfort. Enjoy the natural light from the large windows.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3808636a-4133-436a-995b-6c6de6722d9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-62cc-754a-8c2a-f723a38e45ed.webp",
      "image_media": {
        "alt_text": "Modern dining and desk area in an apartment with large windows and stylish decor.",
        "public_id": "019fa4fa-62cc-754a-8c2a-f723a38e45ed",
        "storage_key": "property/6767906449165640/019fa4fa-62cc-754a-8c2a-f723a38e45ed.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a dedicated workspace and elegant dining area in this apartment. Featuring large windows for natural light and chic furnishings.",
      "link": "",
      "alt_text": "Modern dining and desk area in an apartment with large windows and stylish decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1003e28-5186-425a-8f2c-060aefc0cf13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-61f6-709d-a561-a269b380156a.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, and view into bedroom",
        "public_id": "019fa4fa-61f6-709d-a561-a269b380156a",
        "storage_key": "property/6767906449165640/019fa4fa-61f6-709d-a561-a269b380156a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center, and comfortable seating. A glimpse into the adjacent bedroom adds to the spacious feel.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, and view into bedroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f7465187-3da5-4df5-9ca0-fb32f78ee860",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5ab2-74ae-82b7-a9dd84eab160.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and desk.",
        "public_id": "019fa4fa-5ab2-74ae-82b7-a9dd84eab160",
        "storage_key": "property/6767906449165640/019fa4fa-5ab2-74ae-82b7-a9dd84eab160.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and a dedicated workspace with a desk and chair.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, coffee table, and desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc170fc1-e8e2-4f68-8957-a774797b5165",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and kitchen bar with stools.",
        "public_id": "019fa4fa-5941-76cb-8b69-8278a31f007f",
        "storage_key": "property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, decorative coffee table, and a breakfast bar connecting to the kitchen.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, and kitchen bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0fc5fa6-87c6-40c7-ae7f-936750487020",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5514-7603-bb2d-6b87d993d9f1.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019fa4fa-5514-7603-bb2d-6b87d993d9f1",
        "storage_key": "property/6767906449165640/019fa4fa-5514-7603-bb2d-6b87d993d9f1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a spacious vanity, a standard toilet, and a bathtub/shower combination.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a52a1ec2-bd9d-42e7-a7aa-6464e5f07934",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-4f06-74b2-98b3-3942c1aa4ba1.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and a ceiling fan.",
        "public_id": "019fa4fa-4f06-74b2-98b3-3942c1aa4ba1",
        "storage_key": "property/6767906449165640/019fa4fa-4f06-74b2-98b3-3942c1aa4ba1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, ample natural light from the large windows, and a stylish ceiling fan.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db3883d1-c00b-486f-9487-6e8206a46353",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-4cc3-7328-8521-5c44df0f14c9.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and TV.",
        "public_id": "019fa4fa-4cc3-7328-8521-5c44df0f14c9",
        "storage_key": "property/6767906449165640/019fa4fa-4cc3-7328-8521-5c44df0f14c9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A well-appointed living room featuring a fireplace, television, and comfortable seating, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e366b916-63ab-493b-8b81-6ca86630ca2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-4fa7-713c-a2b7-f02ea706021c.webp",
      "image_media": {
        "alt_text": "Dining table and chairs next to a desk and window.",
        "public_id": "019fa4fa-4fa7-713c-a2b7-f02ea706021c",
        "storage_key": "property/6767906449165640/019fa4fa-4fa7-713c-a2b7-f02ea706021c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals and work from home in this versatile dining and living space.",
      "link": "",
      "alt_text": "Dining table and chairs next to a desk and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cef68792-84df-47be-a4fe-5fefc3874e82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-4f33-732c-8c98-ec8955015631.webp",
      "image_media": {
        "alt_text": "A home office setup with a desk, chair, and windows looking out to trees and houses.",
        "public_id": "019fa4fa-4f33-732c-8c98-ec8955015631",
        "storage_key": "property/6767906449165640/019fa4fa-4f33-732c-8c98-ec8955015631.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this bright and airy home office, perfect for remote work or study. Natural light streams in through large windows.",
      "link": "",
      "alt_text": "A home office setup with a desk, chair, and windows looking out to trees and houses.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54328745-5c42-4c06-b148-d90347d5d3fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-4eea-7008-819c-f82a56fcd651.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "019fa4fa-4eea-7008-819c-f82a56fcd651",
        "storage_key": "property/6767906449165640/019fa4fa-4eea-7008-819c-f82a56fcd651.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Open-concept living and dining area with a modern kitchen featuring granite countertops and stainless steel appliances. Perfect for entertaining guests.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68b55c65-6ee9-448b-98fc-e8527e735f75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-4233-7327-8219-f52ca1993e2d.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, and dining area.",
        "public_id": "019fa4fa-4233-7327-8219-f52ca1993e2d",
        "storage_key": "property/6767906449165640/019fa4fa-4233-7327-8219-f52ca1993e2d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and a dining area, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_141bd387-2aca-4e20-9f20-a42e92080702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-3e80-734a-b8f8-476de0c40ff0.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and a breakfast bar.",
        "public_id": "019fa4fa-3e80-734a-b8f8-476de0c40ff0",
        "storage_key": "property/6767906449165640/019fa4fa-3e80-734a-b8f8-476de0c40ff0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wooden cabinetry, a microwave, stove, refrigerator, and a convenient breakfast bar area.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3b4cdab-9501-434f-bb28-44afd65649f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-3a3c-701d-8a81-da4a2fa946db.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with sofa, coffee table, TV, and bar stools.",
        "public_id": "019fa4fa-3a3c-701d-8a81-da4a2fa946db",
        "storage_key": "property/6767906449165640/019fa4fa-3a3c-701d-8a81-da4a2fa946db.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern and inviting living room and kitchen space featuring a comfortable sofa, a stylish coffee table, and a well-equipped kitchen area with bar seating.",
      "link": "",
      "alt_text": "Living room and kitchen area with sofa, coffee table, TV, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fdb2375-b4bd-432b-8d65-77fc90b99588",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-385c-72a8-bf1b-a7b89874fdeb.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, dining table, and chairs.",
        "public_id": "019fa4fa-385c-72a8-bf1b-a7b89874fdeb",
        "storage_key": "property/6767906449165640/019fa4fa-385c-72a8-bf1b-a7b89874fdeb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, accent armchair, and a coffee table, adjacent to a dining area with modern chairs.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, coffee table, dining table, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ee38c51-6ca3-4376-9742-9aaf92b7d5df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-37d3-761c-8552-fdf7c26ac1b1.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, accent chair, coffee table, and TV.",
        "public_id": "019fa4fa-37d3-761c-8552-fdf7c26ac1b1",
        "storage_key": "property/6767906449165640/019fa4fa-37d3-761c-8552-fdf7c26ac1b1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, colorful accent chair, and a large coffee table. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, accent chair, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4688ee92-c1a2-4dfb-b6a5-29840d3b5c9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-395e-773f-8c5c-80daff27cf51.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances including a microwave and refrigerator, and a large island with a basket of snacks.",
        "public_id": "019fa4fa-395e-773f-8c5c-80daff27cf51",
        "storage_key": "property/6767906449165640/019fa4fa-395e-773f-8c5c-80daff27cf51.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample wood cabinetry, a microwave, refrigerator, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white appliances including a microwave and refrigerator, and a large island with a basket of snacks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a27ad0b6-e9ee-4c8a-80d0-e8635e4f078b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-25f2-7596-af9f-72651ede9094.webp",
      "image_media": {
        "alt_text": "A well-lit bedroom with a king-size bed, dark wood furniture, and floral wall art.",
        "public_id": "019fa4fa-25f2-7596-af9f-72651ede9094",
        "storage_key": "property/6767906449165640/019fa4fa-25f2-7596-af9f-72651ede9094.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy and stylish bedroom featuring a comfortable king-size bed, elegant dark wood furniture including a dresser and nightstands, and decorative floral artwork above the headboard.",
      "link": "",
      "alt_text": "A well-lit bedroom with a king-size bed, dark wood furniture, and floral wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b13da48-14a0-4d0c-9ac3-26343fc06e6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-25f4-728c-ac7b-7b2294926c66.webp",
      "image_media": {
        "alt_text": "Dining area with round glass-top table, two white modern chairs, and abstract art.",
        "public_id": "019fa4fa-25f4-728c-ac7b-7b2294926c66",
        "storage_key": "property/6767906449165640/019fa4fa-25f4-728c-ac7b-7b2294926c66.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this bright dining area, featuring a stylish round table, two unique modern chairs, and vibrant abstract artwork, perfect for any taste.",
      "link": "",
      "alt_text": "Dining area with round glass-top table, two white modern chairs, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9429b74c-4bae-4c94-97a3-50577b1fee33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-d539-74cc-90f8-06aeba317274.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "019fa4f9-d539-74cc-90f8-06aeba317274",
        "storage_key": "property/6767906449165640/019fa4f9-d539-74cc-90f8-06aeba317274.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight training equipment, and free weights for a comprehensive workout.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, free weights, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a41b9e39-2c70-4f79-be2b-82703680d1ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-d307-7599-98fd-8b362f609e0e.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019fa4f9-d307-7599-98fd-8b362f609e0e",
        "storage_key": "property/6767906449165640/019fa4f9-d307-7599-98fd-8b362f609e0e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a0f0fa6-1422-4e9a-adc2-4fee5be81c26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-d940-723f-8fec-3e349104fc15.webp",
      "image_media": {
        "alt_text": "Spacious living area with fireplace and comfortable seating.",
        "public_id": "019fa4f9-d940-723f-8fec-3e349104fc15",
        "storage_key": "property/6767906449165640/019fa4f9-d940-723f-8fec-3e349104fc15.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace and elegant seating arrangements, perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Spacious living area with fireplace and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f36a0164-6875-4917-a2f7-2c2d94e11984",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-d066-716d-bf43-9dd1ff0c72a5.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019fa4f9-d066-716d-bf43-9dd1ff0c72a5",
        "storage_key": "property/6767906449165640/019fa4f9-d066-716d-bf43-9dd1ff0c72a5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, perfect for relaxing and soaking up the sun. The pool area is equipped with comfortable lounge chairs and shaded umbrellas for your ultimate comfort.",
      "link": "",
      "alt_text": "Sparkling outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cab08b22-1996-48ea-9c17-e430b9c093b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-c35f-76fd-bc2b-35956b60da4b.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including ramps and a tunnel.",
        "public_id": "019fa4f9-c35f-76fd-bc2b-35956b60da4b",
        "storage_key": "property/6767906449165640/019fa4f9-c35f-76fd-bc2b-35956b60da4b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, featuring agility equipment for your furry friend to play and train.",
      "link": "",
      "alt_text": "Dog park with agility equipment including ramps and a tunnel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_172ad911-7409-45ee-83d1-ca58f44cc335",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-c2a7-71af-88f8-f94a6102f72e.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including ramps, tunnels, and weave poles.",
        "public_id": "019fa4f9-c2a7-71af-88f8-f94a6102f72e",
        "storage_key": "property/6767906449165640/019fa4f9-c2a7-71af-88f8-f94a6102f72e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our community dog park, perfect for your furry friends to play and exercise with agility obstacles.",
      "link": "",
      "alt_text": "Dog park with agility equipment including ramps, tunnels, and weave poles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e695e82-9347-411f-8441-3273a528e3ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-a544-764e-af6e-3d5f9d231e69.webp",
      "image_media": {
        "alt_text": "Pond with fountains and apartment buildings in the background.",
        "public_id": "019fa4f9-a544-764e-af6e-3d5f9d231e69",
        "storage_key": "property/6767906449165640/019fa4f9-a544-764e-af6e-3d5f9d231e69.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the tranquil atmosphere of our community's picturesque pond, complete with soothing fountains, surrounded by lush greenery and apartment buildings.",
      "link": "",
      "alt_text": "Pond with fountains and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b7a6704-d3da-4a92-8dd1-bcf1ec2919c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-ba03-77a9-88e4-288493fa3ee2.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and manicured lawns.",
        "public_id": "019fa4f9-ba03-77a9-88e4-288493fa3ee2",
        "storage_key": "property/6767906449165640/019fa4f9-ba03-77a9-88e4-288493fa3ee2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience comfortable living in our apartment community, featuring well-maintained exteriors and lush green spaces.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_666ca2e0-2e2b-4b61-8866-12486ef1691f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-b1cb-77fd-bb5a-e2b8a9a970d7.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and a parking lot.",
        "public_id": "019fa4f9-b1cb-77fd-bb5a-e2b8a9a970d7",
        "storage_key": "property/6767906449165640/019fa4f9-b1cb-77fd-bb5a-e2b8a9a970d7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with attached garages and a parking lot on a sunny day. Offers convenient parking and storage options.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb402977-85be-43ba-9ca7-f15060f28b40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-a730-74ac-85d5-e265a058bf4a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a pond and walkway.",
        "public_id": "019fa4f9-a730-74ac-85d5-e265a058bf4a",
        "storage_key": "property/6767906449165640/019fa4f9-a730-74ac-85d5-e265a058bf4a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the serene waterfront views from the walking paths surrounding the community. Relax by the pond in this beautiful apartment setting.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a pond and walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4786413a-2776-474a-b10c-e4f7449e06cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-9496-7149-b960-2bb68f172b7d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and tables.",
        "public_id": "019fa4f9-9496-7149-b960-2bb68f172b7d",
        "storage_key": "property/6767906449165640/019fa4f9-9496-7149-b960-2bb68f172b7d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e685833c-7b5a-48ae-bf8b-e52b55579132",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-96c5-74be-9db1-f4af01324834.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019fa4f9-96c5-74be-9db1-f4af01324834",
        "storage_key": "property/6767906449165640/019fa4f9-96c5-74be-9db1-f4af01324834.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge seating and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_acaad79d-42ed-47f1-871d-65e2a19b2d5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-92a7-70ff-b51a-964b8057a769.webp",
      "image_media": {
        "alt_text": "Apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "019fa4f9-92a7-70ff-b51a-964b8057a769",
        "storage_key": "property/6767906449165640/019fa4f9-92a7-70ff-b51a-964b8057a769.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool at this apartment community. Enjoy the sun on a lounge chair or gather with friends at a picnic table.",
      "link": "",
      "alt_text": "Apartment building with an outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4358761-e542-47c7-bee0-d0d4e2525125",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-8c47-74fe-aa77-4a53369e322a.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with garages.",
        "public_id": "019fa4f9-8c47-74fe-aa77-4a53369e322a",
        "storage_key": "property/6767906449165640/019fa4f9-8c47-74fe-aa77-4a53369e322a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior of apartment building with garages. The building features red brick accents and light gray siding.",
      "link": "",
      "alt_text": "Exterior of apartment building with garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_57f90644-341a-4ba4-b34c-47590c6332d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-7e49-73fc-8463-0ff2bac56f4f.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with a stone fireplace, built-in grills, and picnic tables.",
        "public_id": "019fa4f9-7e49-73fc-8463-0ff2bac56f4f",
        "storage_key": "property/6767906449165640/019fa4f9-7e49-73fc-8463-0ff2bac56f4f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and gatherings in our community grilling area, featuring a cozy stone fireplace and convenient picnic tables.",
      "link": "",
      "alt_text": "Outdoor grilling area with a stone fireplace, built-in grills, and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc31a225-f756-43ed-a24d-0eddff6c309f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-7d8e-716b-92fe-fc7fc50bf0cd.webp",
      "image_media": {
        "alt_text": "Villas at Aspen Park monument sign with landscaping.",
        "public_id": "019fa4f9-7d8e-716b-92fe-fc7fc50bf0cd",
        "storage_key": "property/6767906449165640/019fa4f9-7d8e-716b-92fe-fc7fc50bf0cd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Villas at Aspen Park, where modern comfort meets a vibrant community atmosphere. Explore our amenities and find your perfect home.",
      "link": "",
      "alt_text": "Villas at Aspen Park monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_19c48e5b-817c-489d-984c-4e32743a14c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-b775-7509-a180-2e6710254daf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b775-7509-a180-2e6710254daf",
        "storage_key": "property/6767906449165640/019d2709-b775-7509-a180-2e6710254daf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ea91-722e-9f0c-5d993556f0a0",
        "storage_key": "property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_baef2391-170c-4a3c-9ce2-e37f08b96752",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-b771-74d8-b801-593636ba1a91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b771-74d8-b801-593636ba1a91",
        "storage_key": "property/6767906449165640/019d2709-b771-74d8-b801-593636ba1a91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ea91-722e-9f0c-5d993556f0a0",
        "storage_key": "property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f4f918f4-7dfe-48e1-8859-ba720dc9b4dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-b72d-746d-977e-9c6be4f6f482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b72d-746d-977e-9c6be4f6f482",
        "storage_key": "property/6767906449165640/019d2709-b72d-746d-977e-9c6be4f6f482.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ea91-722e-9f0c-5d993556f0a0",
        "storage_key": "property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_99555abf-e156-48f2-8ad1-0564770a5b2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Tulsa Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Buffet, pizza and game chain featuring bumper cars and laser-tag attractions.",
      "poi_long_description": "People say this pizza restaurant offers a buffet with a wide variety of options, including pizza, hot dogs, fried chicken, and desserts, as well as rides, games, and attractions like go-karts and laser tag. They also highlight the fun experience, the friendly staff, and the good value for the price.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-b759-750a-98d9-a047451b930b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b759-750a-98d9-a047451b930b",
        "storage_key": "property/6767906449165640/019d2709-b759-750a-98d9-a047451b930b.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-incredible-pizza-company",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ea91-722e-9f0c-5d993556f0a0",
        "storage_key": "property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_c2900b6a-384a-4615-bc8d-d9f19173b597",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "8008 E 31st St, Tulsa, OK 74145, USA",
      "poi_short_description": "Family-friendly chain restaurant serving country-style grub (fried chicken and meat loaf included) in a folksy setting plus a gift shop.",
      "poi_long_description": "People say this restaurant serves delicious biscuits, cornbread, and catfish. They also highlight the friendly service and the cute gift shop.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-bc4e-75f1-b6e8-fe6fab64b599.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bc4e-75f1-b6e8-fe6fab64b599",
        "storage_key": "property/6767906449165640/019d2709-bc4e-75f1-b6e8-fe6fab64b599.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ok/tulsa/325/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=17797342152323187775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "36.1182373",
      "poi_longitude": "-95.8879068",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-610-0414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ea91-722e-9f0c-5d993556f0a0",
        "storage_key": "property/6767906449165640/019d2709-ea91-722e-9f0c-5d993556f0a0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfYTtqVKNtocRP0RPp2Tc_PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9d841e03-5c34-43b3-97da-e44ec92defb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-bc0a-70df-bf15-1a93cce52e06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bc0a-70df-bf15-1a93cce52e06",
        "storage_key": "property/6767906449165640/019d2709-bc0a-70df-bf15-1a93cce52e06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e998-7309-b7d4-196052af12a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e998-7309-b7d4-196052af12a5",
        "storage_key": "property/6767906449165640/019d2709-e998-7309-b7d4-196052af12a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3091deeb-c072-4ff2-9513-7e3e5f55a373",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-bcaa-757f-9cd4-fc58fcf3ca1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bcaa-757f-9cd4-fc58fcf3ca1d",
        "storage_key": "property/6767906449165640/019d2709-bcaa-757f-9cd4-fc58fcf3ca1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e9ce-765b-b0a0-fa0504a8d0f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e9ce-765b-b0a0-fa0504a8d0f7",
        "storage_key": "property/6767906449165640/019d2709-e9ce-765b-b0a0-fa0504a8d0f7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2f27d3b5-4776-4613-afdc-3bed9745c568",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-bcab-72fc-b2be-c7b7ec431fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bcab-72fc-b2be-c7b7ec431fb6",
        "storage_key": "property/6767906449165640/019d2709-bcab-72fc-b2be-c7b7ec431fb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e9ce-765b-b0a0-fa0504a8d0f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e9ce-765b-b0a0-fa0504a8d0f7",
        "storage_key": "property/6767906449165640/019d2709-e9ce-765b-b0a0-fa0504a8d0f7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_a0419b9b-0d28-4648-a9a1-b4aad7c73ce2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4041 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "Hardware store chain supplying tools, appliances, building materials, paint, and other home-improvement items.",
      "poi_long_description": "People say this home improvement store offers a wide selection of tools and materials. They also highlight the helpful and knowledgeable staff, and the convenient layout.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c08d-7441-83ec-eb1571ef0f39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c08d-7441-83ec-eb1571ef0f39",
        "storage_key": "property/6767906449165640/019d2709-c08d-7441-83ec-eb1571ef0f39.webp",
        "width": 1280,
        "height": 803
      },
      "poi_business_url": "https://www.homedepot.com/l/Tulsa-Central/OK/Tulsa/74145/3913?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=452985764776324488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.1055469",
      "poi_longitude": "-95.9030195",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-632-0069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e998-7309-b7d4-196052af12a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e998-7309-b7d4-196052af12a5",
        "storage_key": "property/6767906449165640/019d2709-e998-7309-b7d4-196052af12a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKbQe2qWStocRiC3NLSdUSQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_310f5ccf-3aef-45c1-bae9-6ebd0ad4f921",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a wide variety of products and helpful staff. They also highlight the convenient self-checkout option.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c079-7378-8633-fcc4bd6831a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c079-7378-8633-fcc4bd6831a2",
        "storage_key": "property/6767906449165640/019d2709-c079-7378-8633-fcc4bd6831a2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Broken-Arrow/1536?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1536-_-na-_-0-_-0&y_source=1_MTE4NDM5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12318214238171197715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.065158",
      "poi_longitude": "-95.767607",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-355-4926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e998-7309-b7d4-196052af12a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e998-7309-b7d4-196052af12a5",
        "storage_key": "property/6767906449165640/019d2709-e998-7309-b7d4-196052af12a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg5dy-UuKtocRE3FavZUW86o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_93246bd4-ca75-431d-84be-7c0c2cd79e13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c196-7205-8319-e0e8f9926778.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c196-7205-8319-e0e8f9926778",
        "storage_key": "property/6767906449165640/019d2709-c196-7205-8319-e0e8f9926778.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e998-7309-b7d4-169c8d06625a",
        "storage_key": "property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8fa88875-a43c-456e-92b3-6c8d3edfc9ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Northeastern State University Broken Arrow",
      "poi_type": "Education",
      "poi_address": "3100 New Orleans St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c1fb-71ab-a3dd-a2e1bae6b1a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c1fb-71ab-a3dd-a2e1bae6b1a5",
        "storage_key": "property/6767906449165640/019d2709-c1fb-71ab-a3dd-a2e1bae6b1a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nsuok.edu/BrokenArrow.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996275873980647977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeastern-state-university-broken-arrow",
      "poi_latitude": "36.019376",
      "poi_longitude": "-95.7485342",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-449-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e998-7309-b7d4-169c8d06625a",
        "storage_key": "property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6bWtJw_7yYcRKYoU9bufdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0d436b00-59ec-4aed-945b-b5bd2e74cede",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c464-704d-a004-47dd2d8199d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c464-704d-a004-47dd2d8199d7",
        "storage_key": "property/6767906449165640/019d2709-c464-704d-a004-47dd2d8199d7.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e998-7309-b7d4-169c8d06625a",
        "storage_key": "property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_3a709087-f8a2-4250-92dc-90916ea5ee8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Martin Regional Library",
      "poi_type": "Education",
      "poi_address": "2601 S Garnett Rd, Tulsa, OK 74129, USA",
      "poi_short_description": "Public library with a range of services, including faxing, computers, and meetings, plus Vietnamese books.",
      "poi_long_description": "People say this public library offers a wide selection of books, comfortable seating, and convenient printing services. They highlight the quiet atmosphere, helpful staff, and friendly librarians. They also like the charging stations and the monthly vegan potluck. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c514-77a0-a01d-8f55de46e4a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c514-77a0-a01d-8f55de46e4a9",
        "storage_key": "property/6767906449165640/019d2709-c514-77a0-a01d-8f55de46e4a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/martin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046822168243383481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-regional-library",
      "poi_latitude": "36.1265968",
      "poi_longitude": "-95.8505489",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e998-7309-b7d4-169c8d06625a",
        "storage_key": "property/6767906449165640/019d2709-e998-7309-b7d4-169c8d06625a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF1eFsi7ztocRuawafrmg6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_dd9ccf89-a029-4bf7-8a60-f2ed600c729a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "TCC Southeast Library",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St Building 7, Room 7200, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c87b-710c-9969-936a7cdd5b7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c87b-710c-9969-936a7cdd5b7b",
        "storage_key": "property/6767906449165640/019d2709-c87b-710c-9969-936a7cdd5b7b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://library.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10341227726380407188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tcc-southeast-library",
      "poi_latitude": "36.0433144",
      "poi_longitude": "-95.8632335",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-595-7701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed4f-72ff-a99c-83e5171fee4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed4f-72ff-a99c-83e5171fee4f",
        "storage_key": "property/6767906449165640/019d2709-ed4f-72ff-a99c-83e5171fee4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdNrW1mNtocRlBlTtNNrg48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_307ebc7a-a0ec-45cd-9fc8-7548fbbec538",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c6e1-731a-9168-4230afedede8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c6e1-731a-9168-4230afedede8",
        "storage_key": "property/6767906449165640/019d2709-c6e1-731a-9168-4230afedede8.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_d3520a12-be59-4a0b-b9af-199a3e60fa55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c868-701a-8eff-dbb905d16fe1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c868-701a-8eff-dbb905d16fe1",
        "storage_key": "property/6767906449165640/019d2709-c868-701a-8eff-dbb905d16fe1.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_049711e5-c782-4183-abfe-2aaf76d6159a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Tiger Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-c99f-7724-847e-ad35e9718708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c99f-7724-847e-ad35e9718708",
        "storage_key": "property/6767906449165640/019d2709-c99f-7724-847e-ad35e9718708.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://batigersports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374532252761582339&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiger-memorial-stadium",
      "poi_latitude": "36.0743308",
      "poi_longitude": "-95.7632923",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-259-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed8a-7264-b5b4-a91f1315f7ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed8a-7264-b5b4-a91f1315f7ab",
        "storage_key": "property/6767906449165640/019d2709-ed8a-7264-b5b4-a91f1315f7ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SOplVCKtocRA-sfZ0_jdlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_bfb26c5d-b013-467e-9c6d-7876135f9b1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "LaFortune Stadium",
      "poi_type": "Entertainment",
      "poi_address": "5840 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Outdoor venue for football (including high school team games) and track-and-field meets.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-cbdb-716f-96e5-2c6d47168beb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cbdb-716f-96e5-2c6d47168beb",
        "storage_key": "property/6767906449165640/019d2709-cbdb-716f-96e5-2c6d47168beb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stadiumconnection.com/stadium.php?id=2469",
      "poi_directions_map_url": "https://maps.google.com/?cid=13587449917492336938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-stadium",
      "poi_latitude": "36.0815865",
      "poi_longitude": "-95.9143588",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed8a-7264-b5b4-a91f1315f7ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed8a-7264-b5b4-a91f1315f7ab",
        "storage_key": "property/6767906449165640/019d2709-ed8a-7264-b5b4-a91f1315f7ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFe-JgY6StocRKpmK57VRkLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_fd49fbdf-17d0-4308-a32d-b425d82baa11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "The Museum Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "400 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Small, locally focused museum highlighting the history, art and genealogy of Broken Arrow.",
      "poi_long_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-cdb2-773f-9c4c-eaa145950320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cdb2-773f-9c4c-eaa145950320",
        "storage_key": "property/6767906449165640/019d2709-cdb2-773f-9c4c-eaa145950320.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brokenarrowmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351764218256934691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-museum-broken-arrow",
      "poi_latitude": "36.0491954",
      "poi_longitude": "-95.7911106",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-258-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ee89-768e-a4df-ce998944977e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ee89-768e-a4df-ce998944977e",
        "storage_key": "property/6767906449165640/019d2709-ee89-768e-a4df-ce998944977e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxSi48KLtocRI8cl0Osi7eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e8b54eaf-37a1-4f5c-b50a-762e6ced22ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-cd10-7369-ac4d-e1193fa8c688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cd10-7369-ac4d-e1193fa8c688",
        "storage_key": "property/6767906449165640/019d2709-cd10-7369-ac4d-e1193fa8c688.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_558966f2-2ed4-473d-a6da-bebb5cded542",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-cf79-7641-9668-e3216f7f836c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cf79-7641-9668-e3216f7f836c",
        "storage_key": "property/6767906449165640/019d2709-cf79-7641-9668-e3216f7f836c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a74d8332-2ac6-48ae-b7d4-dbec1759b5dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d0b2-71ff-9284-1b368acf65f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d0b2-71ff-9284-1b368acf65f2",
        "storage_key": "property/6767906449165640/019d2709-d0b2-71ff-9284-1b368acf65f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4aa51f62-9211-4813-bc82-6564a7377434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1808 N Elm Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, including tanning beds, in a clean environment.",
      "poi_long_description": "People say this gym offers a wide selection of equipment and is clean and well-maintained. They highlight the affordable membership and convenient location. They also like the friendly and supportive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d16e-7201-9279-59b00a8acc88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d16e-7201-9279-59b00a8acc88",
        "storage_key": "property/6767906449165640/019d2709-d16e-7201-9279-59b00a8acc88.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/broken-arrow-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8211862053813118143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0700775",
      "poi_longitude": "-95.7999697",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-739-6224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfEd95mLtocRv2QKlgdl9nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fcfb8e7f-41c4-420d-88ee-e4266311cf58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d2e8-7591-8b68-796f9af5de71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d2e8-7591-8b68-796f9af5de71",
        "storage_key": "property/6767906449165640/019d2709-d2e8-7591-8b68-796f9af5de71.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5484b381-acb3-420b-afab-3e3e8f931120",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "8722 E 71st St Suite 872, Tulsa, OK 74133, USA",
      "poi_short_description": "Chains such as this one sell cosmetics, fragrances and makeup in stores and online, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d3de-7739-8f28-3279a84e4fc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d3de-7739-8f28-3279a84e4fc3",
        "storage_key": "property/6767906449165640/019d2709-d3de-7739-8f28-3279a84e4fc3.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-1113",
      "poi_directions_map_url": "https://maps.google.com/?cid=9163598623872888103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.059026",
      "poi_longitude": "-95.8790444",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-250-9053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUwgJEyMtocRJ60zyGWkK38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_f8e5d206-a690-42ab-a69a-f1cdcf75a336",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Umac Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "6836 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Gym featuring basketball and volleyball courts, plus facilities for wrestling, cheerleading, and other competitions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d568-7761-8235-4059ccb31103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d568-7761-8235-4059ccb31103",
        "storage_key": "property/6767906449165640/019d2709-d568-7761-8235-4059ccb31103.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unionps.org/activities/umac",
      "poi_directions_map_url": "https://maps.google.com/?cid=17233318345147314712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "umac-tulsa",
      "poi_latitude": "36.0641918",
      "poi_longitude": "-95.8694283",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-357-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo05n3rqNtocRGHK6l7oLKe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_92f12091-4ba7-41ab-8d3e-862fe1ca8be1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7990 E 51st St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of fitness and yoga classes, as well as personal training. They also highlight the knowledgeable, supportive, and welcoming instructors, and the motivating atmosphere.\n\nOther reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d5c7-7004-8ca1-c36011d2f13a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d5c7-7004-8ca1-c36011d2f13a",
        "storage_key": "property/6767906449165640/019d2709-d5c7-7004-8ca1-c36011d2f13a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/tulsa/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684131092404226149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "36.0885483",
      "poi_longitude": "-95.8878289",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-984-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXRVgW-NtocRZcjZx1JfJqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c36418d1-2be7-4670-ac2f-4f5d762ed027",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d7c5-7096-8f1c-1894e8cd9b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d7c5-7096-8f1c-1894e8cd9b35",
        "storage_key": "property/6767906449165640/019d2709-d7c5-7096-8f1c-1894e8cd9b35.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f136-778a-b10e-58517a0823a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f136-778a-b10e-58517a0823a0",
        "storage_key": "property/6767906449165640/019d2709-f136-778a-b10e-58517a0823a0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4fa86a60-b109-4db0-8ecb-36d694b7e9aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-d83a-72ee-97af-1fb162f2b722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d83a-72ee-97af-1fb162f2b722",
        "storage_key": "property/6767906449165640/019d2709-d83a-72ee-97af-1fb162f2b722.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f136-778a-b10e-58517a0823a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f136-778a-b10e-58517a0823a0",
        "storage_key": "property/6767906449165640/019d2709-f136-778a-b10e-58517a0823a0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_26543186-3cc8-49fb-b907-e633e1564f6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-da01-737d-857d-26d09ebb3dce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-da01-737d-857d-26d09ebb3dce",
        "storage_key": "property/6767906449165640/019d2709-da01-737d-857d-26d09ebb3dce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f133-73f9-b01f-bc56cdcd55a7",
        "storage_key": "property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_48c0e321-623f-442d-b717-b9c80bfae90a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-db8c-729a-b2c6-1644d379ed85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-db8c-729a-b2c6-1644d379ed85",
        "storage_key": "property/6767906449165640/019d2709-db8c-729a-b2c6-1644d379ed85.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f133-73f9-b01f-bc56cdcd55a7",
        "storage_key": "property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ec86ec7d-e776-474e-ba19-d1cfd78907c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-dc0d-75fc-b9a5-7e84f274eb20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dc0d-75fc-b9a5-7e84f274eb20",
        "storage_key": "property/6767906449165640/019d2709-dc0d-75fc-b9a5-7e84f274eb20.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f133-73f9-b01f-bc56cdcd55a7",
        "storage_key": "property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6d50c086-0b8f-40f8-a358-3d9740e95c51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-dd33-77be-a9f6-25f16f13da83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dd33-77be-a9f6-25f16f13da83",
        "storage_key": "property/6767906449165640/019d2709-dd33-77be-a9f6-25f16f13da83.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f133-73f9-b01f-bc56cdcd55a7",
        "storage_key": "property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_61892400-19d3-4845-83d1-d5d1b745d3b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-dfc0-704b-a858-ea84fecaac77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dfc0-704b-a858-ea84fecaac77",
        "storage_key": "property/6767906449165640/019d2709-dfc0-704b-a858-ea84fecaac77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f133-73f9-b01f-bc56cdcd55a7",
        "storage_key": "property/6767906449165640/019d2709-f133-73f9-b01f-bc56cdcd55a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6bdc9455-7e27-40ff-a4f7-b453cfc860bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Harvey Young Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1419 S 135th E Ave, Tulsa, OK 74108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e178-73ba-868b-986235b57fc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e178-73ba-868b-986235b57fc6",
        "storage_key": "property/6767906449165640/019d2709-e178-73ba-868b-986235b57fc6.webp",
        "width": 1242,
        "height": 932
      },
      "poi_business_url": "http://harvey-young-airport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091711320843246332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-young-airport",
      "poi_latitude": "36.1412138",
      "poi_longitude": "-95.8256711",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-298-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-f20a-762e-992e-c326c8d06031.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f20a-762e-992e-c326c8d06031",
        "storage_key": "property/6767906449165640/019d2709-f20a-762e-992e-c326c8d06031.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJffM4REPztocR_FoKDq6s7Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b324b5f0-0cd4-4b6d-9785-513a328d6943",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e098-75bb-926c-e63548cac1da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e098-75bb-926c-e63548cac1da",
        "storage_key": "property/6767906449165640/019d2709-e098-75bb-926c-e63548cac1da.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4f9c052a-a864-4f97-88a5-7986625e3b58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e201-73a3-9d43-5876878f0f0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e201-73a3-9d43-5876878f0f0a",
        "storage_key": "property/6767906449165640/019d2709-e201-73a3-9d43-5876878f0f0a.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4682a5f0-8490-4a0d-a4ea-893e1b51c5cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0c10f753-a4d7-4a72-a64e-4e03c657b1df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e48a-702b-ae16-700118b37d83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e48a-702b-ae16-700118b37d83",
        "storage_key": "property/6767906449165640/019d2709-e48a-702b-ae16-700118b37d83.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed87-7259-824e-3d2e6c5d2b9d",
        "storage_key": "property/6767906449165640/019d2709-ed87-7259-824e-3d2e6c5d2b9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9afc66b2-1866-4fea-9c92-c26a370b3fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "City of Broken Arrow",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 S 1st St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-e554-77e4-b579-009fca3f4c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e554-77e4-b579-009fca3f4c7e",
        "storage_key": "property/6767906449165640/019d2709-e554-77e4-b579-009fca3f4c7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981682047998685423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-broken-arrow",
      "poi_latitude": "36.0510555",
      "poi_longitude": "-95.7899817",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d2709-ed4f-72ff-a99c-83e5171fee4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed4f-72ff-a99c-83e5171fee4f",
        "storage_key": "property/6767906449165640/019d2709-ed4f-72ff-a99c-83e5171fee4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQP1vMOLtocR7_CiSld8R6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a10d09ae-08fd-477a-abc6-231a164950f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Arrowhead Elementary School",
      "poi_type": "Education",
      "poi_address": "915 W Norman St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-8fa7-73fa-81ef-fc04ea717303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8fa7-73fa-81ef-fc04ea717303",
        "storage_key": "property/6767906449165640/019d7913-8fa7-73fa-81ef-fc04ea717303.webp",
        "width": 1280,
        "height": 797
      },
      "poi_business_url": "https://www.baschools.org/o/aes",
      "poi_directions_map_url": "https://maps.google.com/?cid=18158338255018863810&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arrowhead-elementary-school",
      "poi_latitude": "36.0661023",
      "poi_longitude": "-95.803687",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-259-4390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafvUVZCLtocRwizJmW9g__s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_27d9d043-3ce6-401b-8405-22c651374ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Peters Elementary School",
      "poi_type": "Education",
      "poi_address": "2900 W College St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://peters.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10680121682788176157&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peters-elementary-school",
      "poi_latitude": "36.05484550000001",
      "poi_longitude": "-95.8265328",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCcxt9hKMtocRHVGJtBVqN5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ca983ebf-c0b2-417d-95fb-2966ae07d6f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Rhoades Elementary School",
      "poi_type": "Education",
      "poi_address": "320 E Midway St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.baschools.org/o/RHES",
      "poi_directions_map_url": "https://maps.google.com/?cid=16549496881889088352&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rhoades-elementary-school",
      "poi_latitude": "36.0585332",
      "poi_longitude": "-95.7868188",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-259-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYfZ8WceLtocRYBNvKLufq-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f631b4de-a356-45f1-82ea-9b5db23b1fff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Oneta Ridge Middle School",
      "poi_type": "Education",
      "poi_address": "6800 E Quincy Pl, Broken Arrow, OK 74014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-8dc2-779b-ba86-760c0ee4e926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8dc2-779b-ba86-760c0ee4e926",
        "storage_key": "property/6767906449165640/019d7913-8dc2-779b-ba86-760c0ee4e926.webp",
        "width": 640,
        "height": 1136
      },
      "poi_business_url": "https://www.baschools.org/o/orms",
      "poi_directions_map_url": "https://maps.google.com/?cid=1244949373414424418&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oneta-ridge-middle-school",
      "poi_latitude": "36.0375367",
      "poi_longitude": "-95.7049347",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-259-4360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxSf592VhtocRYj-27dvyRhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7d8ed62a-f014-474c-9dac-34a9cea0ffcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Oliver Middle School",
      "poi_type": "Education",
      "poi_address": "3100 W New Orleans St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-90d8-727b-a63f-21ef6f0b10dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-90d8-727b-a63f-21ef6f0b10dc",
        "storage_key": "property/6767906449165640/019d7913-90d8-727b-a63f-21ef6f0b10dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.baschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11642383297385948844&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oliver-middle-school",
      "poi_latitude": "36.0189359",
      "poi_longitude": "-95.8270601",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-259-4590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYbCXK92LtocRrGahy-wNkqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8c6d00d8-1329-45b0-9de3-b37d3970c808",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Union High School Freshman Academy",
      "poi_type": "Education",
      "poi_address": "7616 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-8ce1-7768-b8bb-4fd66c204024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8ce1-7768-b8bb-4fd66c204024",
        "storage_key": "property/6767906449165640/019d7913-8ce1-7768-b8bb-4fd66c204024.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://ufa.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11673188432274153300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school-freshman-academy",
      "poi_latitude": "36.0524715",
      "poi_longitude": "-95.8526699",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-357-4324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNSlfnDaMtocRVF_mLQh__6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_750ecefa-887c-41cf-8506-1ede4e9ee611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Broken Arrow High School",
      "poi_type": "Education",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-9aee-7109-915d-63dfa08e5504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9aee-7109-915d-63dfa08e5504",
        "storage_key": "property/6767906449165640/019d7913-9aee-7109-915d-63dfa08e5504.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.baschools.org/o/bahs",
      "poi_directions_map_url": "https://maps.google.com/?cid=9874418802231035849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-high-school",
      "poi_latitude": "36.0739737",
      "poi_longitude": "-95.766474",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-259-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOVb0n1GKtocRyUdrbpX7CIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f48cfdc8-3384-460b-a875-e0e06dedff27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Rhema Bible Training College",
      "poi_type": "Education",
      "poi_address": "1025 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-9871-77db-a021-0bdb4ed3e11b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9871-77db-a021-0bdb4ed3e11b",
        "storage_key": "property/6767906449165640/019d7913-9871-77db-a021-0bdb4ed3e11b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rbtc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11947881279901651820&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rhema-bible-training-college",
      "poi_latitude": "36.0590515",
      "poi_longitude": "-95.8055648",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcwlpHh6LtocRbNMTs7hmz6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5b24d776-5dcf-4a1d-8235-7d883e508b16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-9d0f-710b-a31b-6d39e7705f74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9d0f-710b-a31b-6d39e7705f74",
        "storage_key": "property/6767906449165640/019d7913-9d0f-710b-a31b-6d39e7705f74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acba-728e-822e-28d33049e292",
        "storage_key": "property/6767906449165640/019cfb4b-acba-728e-822e-28d33049e292.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8ebeac96-cfbc-49ce-b4e3-ae510dee5d86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Andolini's Pizzeria Broken Arrow",
      "poi_type": "Restaurants",
      "poi_address": "222 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Italian dishes & specialty pizzas cooked up with homemade mozzarella cheese in a bustling locale.",
      "poi_long_description": "People say this pizza restaurant serves delicious pepperoni pizza, calzones, and garlic knots. They highlight the generous portions, reasonable prices, and the availability of a lunch special. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-a4bf-7019-aaa9-ff3373be2bcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a4bf-7019-aaa9-ff3373be2bcd",
        "storage_key": "property/6767906449165640/019d7913-a4bf-7019-aaa9-ff3373be2bcd.webp",
        "width": 1280,
        "height": 866
      },
      "poi_business_url": "https://andopizza.com/location/broken-arrow/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1078595168232097132&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andolini-s-pizzeria-broken-arrow",
      "poi_latitude": "36.0506434",
      "poi_longitude": "-95.7910135",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-940-2770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuz2OUMKLtocRbEXtQpfw9w4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_ece7bf43-1845-45ae-b6a0-55f3ad435ca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Ted's Café Escondido",
      "poi_type": "Restaurants",
      "poi_address": "501 W Albany Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Local chain serving traditional Mexican fare in a relaxed space with traditional touches.",
      "poi_long_description": "People say this Mexican restaurant serves amazing nachos, fresh tortillas, and complimentary salsa, cheese dip, and sopapillas. They also highlight the attentive service, friendly staff, and clean atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-a856-737f-ae62-b8e7af319398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a856-737f-ae62-b8e7af319398",
        "storage_key": "property/6767906449165640/019d7913-a856-737f-ae62-b8e7af319398.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tedscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11328924120112948582&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ted-s-caf-escondido",
      "poi_latitude": "36.0749427",
      "poi_longitude": "-95.7968651",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-254-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytG_2uMtocRZuWvynZsOJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9b25f289-4867-4d2c-8710-d6f3f171386b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Oklahoma Joe's Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "6175 E 61st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_long_description": "People say this barbecue restaurant serves tasty ribs, pulled pork, and burnt ends. They also highlight the fast service, friendly staff, and clean, happy atmosphere.\n\nOther reviews mention the brisket can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-a999-74ab-ada4-fd528722e811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a999-74ab-ada4-fd528722e811",
        "storage_key": "property/6767906449165640/019d7913-a999-74ab-ada4-fd528722e811.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://okjoes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10293820666620048956&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-joe-s-barbecue",
      "poi_latitude": "36.075939",
      "poi_longitude": "-95.906952",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-894-4447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ92aoYeStocRPHZ2d1v_2o4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_dd1b777a-e8e5-4585-9a3b-d4d82d6250e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Main Street Tavern",
      "poi_type": "Restaurants",
      "poi_address": "200 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Restaurant/sports bar featuring classic American food, late-night pub grub, live jazz & happy hour.",
      "poi_long_description": "People say this restaurant serves delicious burgers, fish and chips, and steaks. They also highlight the friendly service, laid-back atmosphere, and reasonable prices.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-acef-7124-8744-9c5f1e71db6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-acef-7124-8744-9c5f1e71db6f",
        "storage_key": "property/6767906449165640/019d7913-acef-7124-8744-9c5f1e71db6f.webp",
        "width": 550,
        "height": 445
      },
      "poi_business_url": "https://www.scarpa-rc.com/main-street-tavern",
      "poi_directions_map_url": "https://maps.google.com/?cid=16367268087796209159&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-street-tavern",
      "poi_latitude": "36.0512715",
      "poi_longitude": "-95.7909875",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-872-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdREoT8KLtocRBxauvJs3JOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b23804f7-af46-4a86-9f87-879b8565a6a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "251 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious fried catfish, prime rib, and chicken piccata. They highlight the excellent service, friendly staff, and the cozy, welcoming atmosphere, perfect for gatherings with family and friends. They also like the generous portions and reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-b0e1-7450-9dc9-a6416ff7529c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b0e1-7450-9dc9-a6416ff7529c",
        "storage_key": "property/6767906449165640/019d7913-b0e1-7450-9dc9-a6416ff7529c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-broken-arrow/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7215259568967514265&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "36.0694444",
      "poi_longitude": "-95.7894444",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-355-9177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJecfxi7OLtocRmfiLklnAIWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_96472aab-ef24-461a-83ff-ecd9575a7542",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Rustic Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "210 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Rustic steakhouse in the Rose District Plaza serving up choice cuts and other hearty fare, plus cocktails.",
      "poi_long_description": "People say this chophouse restaurant serves delicious steaks, crab cakes, and lobster bisque. They also highlight the cozy and elegant atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-b15b-726b-a79d-464627f9fb03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b15b-726b-a79d-464627f9fb03",
        "storage_key": "property/6767906449165640/019d7913-b15b-726b-a79d-464627f9fb03.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.rusticchophouseba.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15410778395433896171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rustic-chophouse",
      "poi_latitude": "36.0509556",
      "poi_longitude": "-95.7910163",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-355-0814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0Fbt_-LtocR6wgaBE0V3tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2c36c3c0-9f6c-43f7-b38f-49a3909e1420",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Kofu Sushi Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "813 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-b308-76a9-a22f-bf8613bc1cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b308-76a9-a22f-bf8613bc1cfb",
        "storage_key": "property/6767906449165640/019d7913-b308-76a9-a22f-bf8613bc1cfb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/share/1BJEYF3MrY/?mibextid=wwXIfr",
      "poi_directions_map_url": "https://maps.google.com/?cid=12720127395980808486&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kofu-sushi-restaurant",
      "poi_latitude": "36.060682",
      "poi_longitude": "-95.7991394",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-505-3455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr66VPgCLtocRJpEm93j4hrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_23f14bcb-b1d5-43df-95a7-2d6c89486440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "All About Cha Cafe & Restaurant - Broken Arrow",
      "poi_type": "Restaurants",
      "poi_address": "820 N Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Cozy spot for breakfast, bubble tea, and coffee, plus Korean fare such as bento boxes and bulgogi wraps.",
      "poi_long_description": "People say this bubble tea store offers a wide variety of teas, as well as food options like sushi and cheesecake. They highlight the reasonable prices and the relaxed, peaceful atmosphere, perfect for chatting or meetings. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-b3ed-774d-9fb7-8e7d96b6016d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b3ed-774d-9fb7-8e7d96b6016d",
        "storage_key": "property/6767906449165640/019d7913-b3ed-774d-9fb7-8e7d96b6016d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://allaboutchaba.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17532261031567663262&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "all-about-cha-cafe-restaurant-broken-arrow",
      "poi_latitude": "36.0593669",
      "poi_longitude": "-95.8159067",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-940-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2p8zOaNtocRnqADsIQaT_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c7ad4dde-184c-4d0e-91cd-31f3795caedb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Trang Le Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "723 N Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Pared-down shopping-center outlet for Vietnamese noodle soups, rice dishes & salads.",
      "poi_long_description": "People say this Vietnamese restaurant serves delicious pho and bun. They highlight the good value and authentic flavors. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-bbed-71e8-a1c5-6f90b5d96cbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bbed-71e8-a1c5-6f90b5d96cbd",
        "storage_key": "property/6767906449165640/019d7913-bbed-71e8-a1c5-6f90b5d96cbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tranglerestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6404962735596439981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trang-le-restaurant",
      "poi_latitude": "36.0593289",
      "poi_longitude": "-95.814339",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-994-7676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6XXc3WMtocRrQnXTqz_4lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_ffa4eae7-0e52-4dbc-a068-30763772a032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "50's Diner",
      "poi_type": "Restaurants",
      "poi_address": "1500 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this American restaurant serves delicious burgers, chicken strips, and pork tenderloin sandwiches. They highlight the reasonable prices, generous portions, and retro 50s diner vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-bc8d-764e-b136-412d9373bcce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bc8d-764e-b136-412d9373bcce",
        "storage_key": "property/6767906449165640/019d7913-bc8d-764e-b136-412d9373bcce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://50sdinerok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=162261159393487439&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "50-s-diner",
      "poi_latitude": "36.0613095",
      "poi_longitude": "-95.8099471",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-806-6999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accd-701c-abe5-879737cebda5",
        "storage_key": "property/6767906449165640/019cfb4b-accd-701c-abe5-879737cebda5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXV6Yk4uLtocRT-p9Lqp3QAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_10e706c1-9467-47f8-ad32-60a272a10c38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Egg It On Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1131 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Unassuming, simple diner serving comfort foods like omelets & burgers for breakfast & lunch.",
      "poi_long_description": "People say this cafe serves delicious crepes, breakfast tostadas, and Baja potatoes. They highlight the reasonable prices, clean atmosphere, and friendly staff. They also like the quiet and pleasant vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-bcc0-703c-9f26-03d4dc66b42d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bcc0-703c-9f26-03d4dc66b42d",
        "storage_key": "property/6767906449165640/019d7913-bcc0-703c-9f26-03d4dc66b42d.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "http://www.eggitoncafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3121501714821878374&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "egg-it-on-cafe",
      "poi_latitude": "36.0442099",
      "poi_longitude": "-95.8137392",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-254-0455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-d447-7438-bedd-a42d696005c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-d447-7438-bedd-a42d696005c9",
        "storage_key": "property/6767906449165640/019d7913-d447-7438-bedd-a42d696005c9.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJWYsmGmyMtocRZhK7bUXNUSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_bb99a7ff-4df5-4dd9-8935-cbdef31a633a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide selection of pantry staples, bread, and snacks, including the Aldi brand. They highlight the great prices, convenient size, and the quality of the house brands. They also like the cordial cashiers and the quick and easy shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-bea1-7006-b2d6-e8757b722c38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bea1-7006-b2d6-e8757b722c38",
        "storage_key": "property/6767906449165640/019d7913-bea1-7006-b2d6-e8757b722c38.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/broken-arrow/2400-w-kenosha-street/f274",
      "poi_directions_map_url": "https://maps.google.com/?cid=3044546698895851077&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.061961",
      "poi_longitude": "-95.820913",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accf-718d-9d4e-e5f87aebff10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accf-718d-9d4e-e5f87aebff10",
        "storage_key": "property/6767906449165640/019cfb4b-accf-718d-9d4e-e5f87aebff10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWclC5nOMtocRRX7GiRdnQCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a6168d6e-4b27-4950-b3e3-816dc7bd8716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic, and healthy food options, including vegan, vegetarian, and paleo choices. They also highlight the clean and well-organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-c1fe-77b5-ace0-253a7bf78424.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c1fe-77b5-ace0-253a7bf78424",
        "storage_key": "property/6767906449165640/019d7913-c1fe-77b5-ace0-253a7bf78424.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-accf-718d-9d4e-e5f87aebff10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-accf-718d-9d4e-e5f87aebff10",
        "storage_key": "property/6767906449165640/019cfb4b-accf-718d-9d4e-e5f87aebff10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ebad5e29-e6d4-4f82-83c2-ba7c43f0de82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Main Street Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "303 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-c514-73fa-9b9c-a5f310b9bd15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c514-73fa-9b9c-a5f310b9bd15",
        "storage_key": "property/6767906449165640/019d7913-c514-73fa-9b9c-a5f310b9bd15.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17889745247862250417&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-street-square",
      "poi_latitude": "36.0500376",
      "poi_longitude": "-95.7905343",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acbe-7079-a078-4487d8ac6679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acbe-7079-a078-4487d8ac6679",
        "storage_key": "property/6767906449165640/019cfb4b-acbe-7079-a078-4487d8ac6679.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH5C9PcqLtocRsdsP3YQkRfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bdcbf0ff-5ea0-4872-8d0a-61b3b5bd9ba7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Eastside Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Strip malls featuring familiar restaurants, shops and a Target store.",
      "poi_long_description": "People say this shopping center offers great steaks. They also highlight the reasonable prices and early bird specials.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-c539-732d-94aa-43da3c9c9fa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c539-732d-94aa-43da3c9c9fa3",
        "storage_key": "property/6767906449165640/019d7913-c539-732d-94aa-43da3c9c9fa3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=420103559678602685&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastside-market",
      "poi_latitude": "36.0610807",
      "poi_longitude": "-95.8531648",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-461-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acbe-7079-a078-4487d8ac6679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acbe-7079-a078-4487d8ac6679",
        "storage_key": "property/6767906449165640/019cfb4b-acbe-7079-a078-4487d8ac6679.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9w-qcEyMtocRvS2FM_aB1AU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_14b3ae92-b147-4fe8-aae1-79af9fd218e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Woodland Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "8620 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Shopping mall featuring books, coffee, and games, as well as places to eat.",
      "poi_long_description": "People say this shopping center offers a great selection of stores and a wide variety of books. They highlight the convenient parking, quiet atmosphere, and peaceful vibe. They also like the helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019d7913-c64d-70ea-97a9-724ae40fce6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c64d-70ea-97a9-724ae40fce6b",
        "storage_key": "property/6767906449165640/019d7913-c64d-70ea-97a9-724ae40fce6b.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3263024643163273007&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woodland-plaza",
      "poi_latitude": "36.0600223",
      "poi_longitude": "-95.8790826",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-acbe-7079-a078-4487d8ac6679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-acbe-7079-a078-4487d8ac6679",
        "storage_key": "property/6767906449165640/019cfb4b-acbe-7079-a078-4487d8ac6679.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIWdVcpaNtocRL7cX7Z-XSC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8a783ce7-cb58-4b35-8ab1-7754232a10f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Indian Springs Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "indian-springs-elementary-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fab32cf2-df58-4106-b655-956bec8a583c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "poi_name": "Shiloh’s",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "shiloh-s",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f99f713a2356ecf492cc9fe4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6930f0f63d63e87a713485ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9a9217474f877a92a9e89d26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_81f572508ad714c9a465c73a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_06a0c7d4a3810c5a20ae6658",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_846bc26552df030860570da9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_3afe7e4c-6eb7-4c41-92ad-6ad406d5a07d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "rating": "5.0",
      "name": "Jane Egger",
      "text": "It’s so well kept. The grounds are mowed and weeds are gone regularly. The employees are amazing. Competent and polite so it’s not a hassle to get things done and the service is prompt.  I love it here   I’m so glad I choose the villas.  Johnathon and Rodney  are so pleasant and professional. Thanks for a great place to live. Oh, and we have ducks!!!!\n\nWe had a bit of a leak, sent the request in, Rod was there in a jiffy!!!  Problem solved and we are very happy residents.  All the personnel have been amazing!!  Just what I expected when we choose to move here.",
      "date": "2025-08-22",
      "title": ""
    },
    {
      "id": "custom_56b3be6a-bf46-438f-98ce-f0af3551d139",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "rating": "5.0",
      "name": "Desaree French",
      "text": "We’ve lived at Villas 2 years and just renewed for another year! My kids love the watching the ducks swim at the pond, going on a nightly walks is our dogs favorite activity! The complex is perfectly located near everything, (wish they had a playground or something similar for kiddos) otherwise it’s been lovely. Helpful and friendly staff!!",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_a0b83da1-70ab-4cad-9bff-f0dd4df9c353",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "rating": "5.0",
      "name": "Mitch Moss",
      "text": "Everything is good and friendly.  When I moved in 2 years ago, there were problems because of a city wide blackout, but Miranda figured out a work around and got me in.  Maintenance has always been fast and friendly as well.",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_62cc1d76-532f-46d8-8d6c-f3e7ef380e95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "rating": "5.0",
      "name": "Charlene Davison",
      "text": "My daughter and I love it here. Been here 6 yrs now. Maintenance is fantastic. Thank you Rodney. Front office is amazing. 😊💜😊",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7afea46c-1b1d-4b5f-a860-c84637203385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4c-4f82-7388-ba65-adea8d3cbbe6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment complex outdoor swimming pool area with lounge chairs and buildings in background",
        "public_id": "019cfb4c-4f82-7388-ba65-adea8d3cbbe6",
        "storage_key": "property/6767906449165640/019cfb4c-4f82-7388-ba65-adea8d3cbbe6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Villas at Aspen Park Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f478f12465fc653b547d4bc&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-64d4-741d-81a3-3252c4a9fcc7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "villas-at-aspen-park",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640"
    },
    {
      "lead_collector_id": "019cf79e-6540-743b-9aef-9d2248c6da42",
      "lead_source": "LANDING_PAGE",
      "name": "villas-at-aspen-park",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-broken-arrow",
      "search_query": "luxury apartments with pool broken arrow",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Broken Arrow",
      "h2_subtitle": "Discover luxury living with poolside relaxation at Villas at Aspen Park. Enjoy modern amenities in the heart of Broken Arrow for ultimate comfort and convenience.",
      "page_copy": "Discover a place where elegance meets serenity at the Villas at Aspen Park. Our luxury apartments with pool in Broken Arrow reimagine premium living with state-of-the-art amenities, such as a well-equipped fitness center and a welcoming clubhouse poised for socializing. Whether you prefer a leisurely swim or a weekend grilling picnic by our serene pond, our community offers an unparalleled lifestyle.\n\nPositioned in the vibrant Downtown Broken Arrow, Villas at Aspen Park places you at the heart of convenience. Here, sleek design is matched with functional features like patios and dishwashers in each apartment. Enjoy the convenience of having a dedicated property manager on site and a reliable sprinkler system for lush landscaping. Make Villas at Aspen Park your luxurious home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfb4b-8689-7231-ba47-e37d230df35b",
        "storage_key": "property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Broken Arrow",
      "seo_description": "Explore luxury apartments with pool in Broken Arrow at Villas at Aspen Park. Enjoy modern amenities and a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-downtown-broken-arrow",
      "search_query": "dog friendly apartments downtown broken arrow",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Downtown Broken Arrow",
      "h2_subtitle": "Enjoy pet-friendly living at Villas at Aspen Park, located in downtown. Our community welcomes you and your furry friends with open paws.",
      "page_copy": "At the Villas at Aspen Park, we understand that pets are family too. Our dog-friendly apartments in downtown Broken Arrow offer the perfect space for both you and your furry companions to thrive. With our dedicated dog park, you and your pet will enjoy plenty of playtime in a safe, welcoming environment.\n\nNestled in the lively Downtown Broken Arrow area, our community also features modern amenities such as a refreshing pool, clubhouse, and a state-of-the-art fitness center. Each apartment is designed with convenience in mind, offering patios, dishwashers, and on-site management. Embrace a lifestyle designed for both comfort and convenience, where you and your pet are cherished at Villas at Aspen Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfb4b-8689-7231-ba47-e37d230df35b",
        "storage_key": "property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments Downtown Broken Arrow",
      "seo_description": "Find dog friendly apartments in Downtown Broken Arrow at Villas at Aspen Park, where you and your pet enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "generator",
      "page_item_url": "fitness-center-equipped-apartments-aspen-park",
      "search_query": "fitness center equipped apartments near aspen park",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center near Aspen Park",
      "h2_subtitle": "Live a healthy lifestyle at Villas at Aspen Park, featuring a state-of-the-art fitness center and a host of modern amenities for your comfort.",
      "page_copy": "Villas at Aspen Park is your gateway to a balanced lifestyle. Our apartments, located near Aspen Park, are equipped with a state-of-the-art fitness center that makes staying fit a breeze. Whether you are a workout enthusiast or just beginning your fitness journey, you'll find all you need right outside your door.\n\nImmerse yourself in comfort with our one and two-bedroom options, complete with sleek modern features like dishwashers and patios. Beyond the fitness center, enjoy a dip in our refreshing pool or host gatherings in our welcoming clubhouse. Located in Downtown Broken Arrow, Villas at Aspen Park combines convenience and community, ensuring you and your loved ones have everything you need to call this place home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfb4b-8689-7231-ba47-e37d230df35b",
        "storage_key": "property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center near Aspen Park",
      "seo_description": "Discover apartments with a fitness center near Aspen Park. Enjoy modern living at Villas at Aspen Park with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-74012",
      "search_query": "apartments with air conditioning 74012",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in 74012",
      "h2_subtitle": "Enjoy year-round comfort in our air-conditioned apartments at Villas at Aspen Park, located in the vibrant 74012 area of Broken Arrow.",
      "page_copy": "Stay cool and comfortable at Villas at Aspen Park, where our apartments come equipped with efficient air conditioning, perfect for the warm Oklahoma weather. Located in the bustling 74012 area, our community offers a serene living space with a host of modern amenities designed for your lifestyle.\n\nEach apartment includes essential features such as patios and dishwashers, while our property boasts a refreshing pool, a fully-equipped fitness center, and a clubhouse for socializing. Nestled in Downtown Broken Arrow, Villas at Aspen Park provides a perfect balance of comfort, convenience, and community. Make this your home and enjoy peace of mind with a reliable on-site property manager.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfb4b-8689-7231-ba47-e37d230df35b",
        "storage_key": "property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in 74012",
      "seo_description": "Find air-conditioned apartments in 74012 at Villas at Aspen Park, offering modern amenities and a great location in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-rentals-broken-arrow-ok",
      "search_query": "dishwasher-equipped rentals broken arrow ok",
      "category": "Amenity",
      "h1_title": "Dishwasher-Equipped Rentals in Broken Arrow, OK",
      "h2_subtitle": "Experience modern living in Broken Arrow, OK, with our dishwasher-equipped rentals at Villas at Aspen Park, offering convenience at every turn.",
      "page_copy": "At Villas at Aspen Park, we offer dishwasher-equipped rentals in Broken Arrow, OK, so you can spend less time on chores and more enjoying life. Our apartments are designed with modern conveniences, ensuring that your needs are met with efficiency and style.\n\nLocated in the vibrant community of Downtown Broken Arrow, our rentals come with an array of amenities, including a sparkling pool, modern fitness center, and pet-friendly spaces. Each unit features patios perfect for relaxing afternoons, and the convenience of on-site management adds peace of mind. Discover the blend of comfort and contemporary living at Villas at Aspen Park, your new home in Broken Arrow.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfb4b-8689-7231-ba47-e37d230df35b",
        "storage_key": "property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher-Equipped Rentals in Broken Arrow, OK",
      "seo_description": "Discover dishwasher-equipped rentals in Broken Arrow, OK at Villas at Aspen Park, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-downtown-broken-arrow",
      "search_query": "one bedroom apartments downtown broken arrow",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Downtown Broken Arrow",
      "h2_subtitle": "Discover stylish one bedroom apartments at Villas at Aspen Park, located in the heart of Downtown Broken Arrow, offering convenience and modern amenities.",
      "page_copy": "Welcome to Villas at Aspen Park, where our one-bedroom apartments in Downtown Broken Arrow offer the perfect blend of city living and comfort. Each apartment is thoughtfully designed to provide a spacious and cozy retreat, ideal for singles or couples.\n\nLiving in the heart of Downtown Broken Arrow, you'll have easy access to local shops, cafes, and entertainment. Our community boasts modern amenities such as a refreshing pool, a fitness center, and a well-appointed clubhouse. Enjoy afternoons on your private patio or take your furry friend to the nearby dog park. At Villas at Aspen Park, we ensure every detail enhances your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfb4b-8689-7231-ba47-e37d230df35b",
        "storage_key": "property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Downtown Broken Arrow",
      "seo_description": "Explore one bedroom apartments at Villas at Aspen Park in Downtown Broken Arrow, featuring modern amenities and a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165640",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-broken-arrow-ok",
      "search_query": "two bedroom apartments broken arrow ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Broken Arrow, OK",
      "h2_subtitle": "Explore comfortable two bedroom apartments at Villas at Aspen Park, situated in Broken Arrow, OK, offering a host of modern amenities.",
      "page_copy": "Villas at Aspen Park presents spacious two-bedroom apartments in Broken Arrow, OK, perfect for those seeking a comfortable and convenient lifestyle. Our thoughtfully designed floor plans offer ample living space suited for families or rooming with a friend.\n\nNestled in Downtown Broken Arrow, our community features amenities such as a sparkling pool, a state-of-the-art fitness center, and a dog park for your furry companions. Each apartment includes modern conveniences like a dishwasher and outdoor patios, enhancing your living experience. With on-site management and a serene community setting, Villas at Aspen Park makes finding your dream home easy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfb4b-8689-7231-ba47-e37d230df35b",
        "storage_key": "property/6767906449165640/019cfb4b-8689-7231-ba47-e37d230df35b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Broken Arrow, OK",
      "seo_description": "Find spacious two bedroom apartments in Broken Arrow, OK at Villas at Aspen Park, featuring modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5225"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-76DFTDXLBF"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151422"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/villas-at-aspen/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T7S96RTD"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165640/019d1bda-c45e-72e9-bdba-15dcb5aa0d7a.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-329-0403"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IldmUjI0bGd3OS9XQkhGSUdHUDdKYWc9PSIsInZhbHVlIjoiY1pPdE4zREs3ZFJMYkpUY3ovSG83QT09IiwibWFjIjoiMzFmNjQ4YjMzNWQxZTRlNzZiZGEwZDc1OTYxMTlhMmYwMjMyNjM5YmU5OTJhZTM5ZDBkZDUyZmFkNWUyNTY4MCJ9"
    }
  ],
  "custom_qb_id": "5225",
  "custom_ga4_id": "G-76DFTDXLBF",
  "custom_repli_id": "10041151422",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/villas-at-aspen/register/",
  "custom_google_gtm_id": "GTM-T7S96RTD",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165640/019d1bda-c45e-72e9-bdba-15dcb5aa0d7a.pdf",
  "custom_ppc_tracking_phone_number": "877-329-0403",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IldmUjI0bGd3OS9XQkhGSUdHUDdKYWc9PSIsInZhbHVlIjoiY1pPdE4zREs3ZFJMYkpUY3ovSG83QT09IiwibWFjIjoiMzFmNjQ4YjMzNWQxZTRlNzZiZGEwZDc1OTYxMTlhMmYwMjMyNjM5YmU5OTJhZTM5ZDBkZDUyZmFkNWUyNTY4MCJ9"
};

export const generatedAt = '2026-08-27T21:35:07.591Z';
